import { PublishedServiceId } from './ServiceId';
import { PublishedJobId, JobId } from './JobId';

export const majorJobs: JobId[] = [
    PublishedJobId.CabinetmakerCarpenter,
    PublishedJobId.Designer,
    PublishedJobId.IronworkerMetalWorkerZincWorker,
];

export const minorJobs: JobId[] = [
    PublishedJobId.Facade,
    PublishedJobId.FloorTilerAndInstaller,
    PublishedJobId.ProfessionalSecondWork,
    PublishedJobId.RooferCarpenter,
    PublishedJobId.SellerAndInstallerOfFenceAndGate,
    PublishedJobId.UpholstererUpholsteryAndCarpet,
];

const jobs: Readonly<{ [key in PublishedJobId]: Array<`${PublishedServiceId}`> }> = {
    [PublishedJobId.Facade]                           : [],
    [PublishedJobId.FloorTilerAndInstaller]           : [],
    [PublishedJobId.Locksmith]                        : [],
    [PublishedJobId.ProfessionalSecondWork]           : [],
    [PublishedJobId.RooferCarpenter]                  : [],
    [PublishedJobId.SellerAndInstallerOfFenceAndGate] : [],
    [PublishedJobId.UpholstererUpholsteryAndCarpet]   : [],
    [PublishedJobId.WineCellarDesigner]               : [],
    [PublishedJobId.LandscaperGardener]               : [
        PublishedServiceId.CustomTerrace,
        PublishedServiceId.PergolaVerandaAndShelters,
        PublishedServiceId.PoolSpaAndSauna],
    [PublishedJobId.ParquetFloorWorker]: [
        PublishedServiceId.ShopLayout,
        PublishedServiceId.LayoutAndFurnitureCofeeHotelAndRestaurant,
        PublishedServiceId.ParquetFloor,
        PublishedServiceId.WorkspaceLayoutAndFurniture],
    [PublishedJobId.CabinetmakerCarpenter]: [
        PublishedServiceId.Table,
        PublishedServiceId.DeskAndMeetingTable,
        PublishedServiceId.CounterBar,
        PublishedServiceId.StoneAndWorktop,
        PublishedServiceId.StaircaseAndGuardrail,
        PublishedServiceId.CustomTerrace,
        PublishedServiceId.ConsoleAndDressingTable,
        PublishedServiceId.StorageUnitAndCupboard,
        PublishedServiceId.ShopLayout,
        PublishedServiceId.LayoutAndFurnitureCofeeHotelAndRestaurant,
        PublishedServiceId.WorkspaceLayoutAndFurniture,
        PublishedServiceId.InteriorAndOutdoorLayoutAndFurniture,
        PublishedServiceId.FenceAndGate,
        PublishedServiceId.BedroomAndBedding,
        PublishedServiceId.Kitchen,
        PublishedServiceId.DecorationAndLighting,
        PublishedServiceId.Seated,
        PublishedServiceId.PergolaVerandaAndShelters],
    [PublishedJobId.Designer]: [
        PublishedServiceId.CounterBar,
        PublishedServiceId.StorageUnitAndCupboard,
        PublishedServiceId.BedroomAndBedding,
        PublishedServiceId.Seated,
        PublishedServiceId.Kitchen,
        PublishedServiceId.StoneAndWorktop,
        PublishedServiceId.CustomTerrace,
        PublishedServiceId.DecorationAndLighting,
        PublishedServiceId.ShopLayout,
        PublishedServiceId.LayoutAndFurnitureCofeeHotelAndRestaurant,
        PublishedServiceId.WorkspaceLayoutAndFurniture,
        PublishedServiceId.InteriorAndOutdoorLayoutAndFurniture],
    [PublishedJobId.MarbrierStoneCutter]: [
        PublishedServiceId.CounterBar,
        PublishedServiceId.StoneAndWorktop,
        PublishedServiceId.InteriorDoorGlassRoofAndPartition,
        PublishedServiceId.Seated,
        PublishedServiceId.StorageUnitAndCupboard,
        PublishedServiceId.StaircaseAndGuardrail,
        PublishedServiceId.DecorationAndLighting,
        PublishedServiceId.ShopLayout,
        PublishedServiceId.Kitchen,
        PublishedServiceId.LayoutAndFurnitureCofeeHotelAndRestaurant,
        PublishedServiceId.WorkspaceLayoutAndFurniture],
    [PublishedJobId.WindowdoorShutterAndBlindSpecialist]: [
        PublishedServiceId.InteriorDoorGlassRoofAndPartition,
        PublishedServiceId.DoorWindowShutterBlind,
        PublishedServiceId.FrontDoorAndService,
        PublishedServiceId.PergolaVerandaAndShelters],
    [PublishedJobId.KitchenDesigner]: [
        PublishedServiceId.CounterBar,
        PublishedServiceId.Kitchen,
        PublishedServiceId.StorageUnitAndCupboard,
        PublishedServiceId.StoneAndWorktop],
    [PublishedJobId.IronworkerMetalWorkerZincWorker]: [
        PublishedServiceId.Table,
        PublishedServiceId.DeskAndMeetingTable,
        PublishedServiceId.FenceAndGate,
        PublishedServiceId.PergolaVerandaAndShelters,
        PublishedServiceId.StaircaseAndGuardrail],
    [PublishedJobId.GlazierMirrorMaker]: [
        PublishedServiceId.MirroringAndGlazing,
        PublishedServiceId.DecorationAndLighting,
        PublishedServiceId.LayoutAndFurnitureCofeeHotelAndRestaurant,
        PublishedServiceId.ShopLayout],
    [PublishedJobId.SpecialistDeckPatioAndVeranda]: [
        PublishedServiceId.PergolaVerandaAndShelters,
        PublishedServiceId.CustomTerrace],
};

export default jobs;
